import ProjectAPIS from '../api/project-apis';
import CONSTANTS from "@/js/utils/constants";
import ProjectOperationFlowUtils from "@/js/utils/projectOperationFlow";
import Vue from "vue";
let ProjectServices = {

  fetchProjectDetail(projectId) {

    return new Promise((resolve, reject) => {
      console.log(reject);
      ProjectAPIS.getJobDetail(projectId)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchProjectUserRole(projectId, userRole) {
    return new Promise((resolve, reject) => {
      let that = this;
      ProjectAPIS.getJobUser(projectId).then(result => {
        let items = result.data.items;
        let userinfo = JSON.parse(localStorage.getItem("userinfo"));
        let user_name = userinfo.userName;
        let caneditProjectManager = false;
        var jumpFlag = false;
        for (let index = 0; index < items.length; index++) {
          const item = items[index];
          if (item.role == 1) {
            const userinfos = item.user_info;
            for (let index = 0; index < userinfos.length; index++) {
              const userinfo = userinfos[index];
              if (userinfo.user_name == user_name) {
                caneditProjectManager = true;
              }
              jumpFlag = true;
              break;
            }
          }
          if (jumpFlag) {
            break;
          }
        }
        that.setUserRoles(items, userRole);
        userRole.caneditProjectManager = caneditProjectManager;
        resolve(result);
      }).catch(error => {
        reject(error);
      });
    });
  },

  setUserRoles(items, userRole) {
    for (let index = 0; index < items.length; index++) {
      const item = items[index];
      if (item.role == 1) {
        const userinfo = item.user_info[0];
        userRole.projectManager = userinfo.user_name;
        userRole.projectManagerId = userinfo.user_id;
        userRole.initProjectManager = userinfo.user_name;
        userRole.oldProjectManager = userinfo.user_name;
      } else if (item.role == 2) {
        userRole.shareRoles =[];
        userRole.initShareRoles =[];
        const userinfos = item.user_info;
        let userShareRoleNames = [];
        for (let index = 0; index < userinfos.length; index++) {
          const userinfo = userinfos[index];
          userRole.shareRoles.push(userinfo.user_id);
          userShareRoleNames.push(userinfo.user_name);
          userRole.initShareRoles.push(userinfo.user_id);
        }
        userRole["shareRoleInfos"] = userinfos;
        userRole["userShareRoleNames"] = userShareRoleNames;
      } else if (item.role == 3) {
        const userinfo = item.user_info[0];
        userRole.creator = userinfo.user_name;
        userRole.creatorId = userinfo.user_id;
        userRole.creatorExited = false;
        if(userinfo.is_exited){
            userRole.creatorExited = true;
        }
      }
    }
    return userRole;
  },

  patchProjectUerRole(projectId, newUseIds, role) {
    return new Promise((resolve, reject) => {
      let params = {
        job_id: projectId,
        user_ids: newUseIds,
        role: role
      };
      ProjectAPIS.patchJobUser(params).then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  postProjectUerRole(projectId, newUseIds, role) {
    return new Promise((resolve, reject) => {
      let params = {
        job_id: projectId,
        user_ids: newUseIds,
        role: role
      };
      ProjectAPIS.postJobUser(params).then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchRideProject(query) {
    return new Promise((resolve, reject) => {
      let params = {
        page: 1,
        per_page: 1000,
        job_uid: query,
        over: 2,
        ride: 3
      };
      ProjectAPIS.getJobs(params)
        .then(result => {
          let rideProjects = [];
          if (result.data.items.length != 0) {
            result.data.items.forEach(element => {
              let label = element.job_uid;
              rideProjects.push({
                value: label
              });
            });
          }
          resolve(rideProjects);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  checkProjectManagerValidate(projectManager) {
    return new Promise((resolve, reject) => {
      ProjectAPIS.getProjectManagerUsers(projectManager, {
          role: 2
        }) //2 查询项目经理是权限传参为2
        .then(result => {
          let items = result.data.items;
          let validateResult = {
            code: 500,
            data: {
              user_id: null
            }
          };
          for (let index = 0; index < items.length; index++) {
            const item = items[index];
            if (item.user_name === projectManager) {
              validateResult.code = 200;
              validateResult.data.user_id = item.id;
              break;
            }
          }
          resolve(validateResult);
        })
        .catch(error => {
          console.log(error);
          reject(false);
        });
    });
  },

  fetchUsers(qyery) {
    return new Promise((resolve, reject) => {
      ProjectAPIS.getUsers(qyery)
        .then(result => {
          resolve(result.data.items);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  serverSavedRegion(uiShowRegion) {
    switch (uiShowRegion) {
      case "北京":
        return 1;
      case "武汉":
        return 2;
      default:
        break;
    }
  },

  createPreProcessProjectInfo(value,createType) {
    let form = value.form;
    var newParams = JSON.parse(JSON.stringify(form));
    let ride = value.ride;
    if (!ride) {
      Vue.delete(newParams, "ride_job");
    }
    let ids = value.ids;
        if (ids.length == 2) {
          if (ids[0].length) {
            newParams["scene_ids"] = ids[0];
          }
          if (ids[1].length) {
            newParams["scene_json_ids"] = ids[1];
          }
        }
        if(createType == CONSTANTS.CREATE_PROJECT_TYPE.READY){
            newParams["ready"] = 1; 
            Vue.delete(newParams, "region");
            Vue.delete(newParams, "sensitive");
        }else{
            newParams["ready"] = 0; 
            newParams.region = this.serverSavedRegion(newParams.region);
        }
        newParams.deadline = newParams.deadline / 1000;
        newParams.target_ids = value.targetIds;
        newParams.affirm = newParams.affirm == "是" ? 1 : 0;
    if (newParams.device_type == "手机") {
        newParams.device_type_detail = value.device_type_desc1;
    } else {
        newParams.device_type_detail = value.device_type_desc2;
    }
    Vue.delete(newParams, "id");
    Vue.delete(newParams, "job_uid");
    Vue.delete(newParams, "direction_title");
    Vue.delete(newParams, "expenses");
    Vue.delete(newParams, "operation");
    Vue.delete(newParams, "total_count");
    return {
      isValueChanged: true,
      data: newParams
    };
  },

  editPreProcessProjectInfo(value, initValue,createType) {
    let newValue = value.form;
    var editValueCount = 0;
    let newParams = {};
    if (newValue.title != initValue.title) {
      newParams["title"] = newValue.title;
      editValueCount++;
    }

    if (newValue.deadline != initValue.deadline) {
      newParams["deadline"] = newValue.deadline / 1000;
      editValueCount++;
    }

    if (newValue.device_type != initValue.device_type) {
      newParams["device_type"] = newValue.device_type;
      editValueCount++;
    }

    if (newValue.direction_id != initValue.direction_id) {
      newParams["direction_id"] = newValue.direction_id;
      editValueCount++;
    }

    if (newValue.supplier != initValue.supplier) {
      newParams["supplier"] = newValue.supplier;
      editValueCount++;
    }

    if (newValue.sensitive != initValue.sensitive) {
        newParams["sensitive"] = parseInt(newValue.sensitive);
        editValueCount++;
      }

    if (newValue.comment != initValue.comment) {
      newParams["comment"] = newValue.comment;
      editValueCount++;
    }

    if (newValue.affirm != initValue.affirm) {
      newParams["affirm"] = (newValue.affirm == "是" ? 1 : 0);
      editValueCount++;
    }

    let ride = value.ride;
    if (ride) {
      if (newValue.ride_job != initValue.ride_job) {
        newParams["ride_job"] = newValue.ride_job;
        editValueCount++;
      }
    }

    let ids = value.ids;
    if (ids.length == 2) {
      newParams["scene_ids"] = ids[0];
      editValueCount++;
      newParams["scene_json_ids"] = ids[1];
      editValueCount++;
    }

    if (value.targetIds) {
      newParams["target_ids"] = value.targetIds;
      editValueCount++;
    }

    if (newValue.expense_ids.join(",") != initValue.expense_ids.join(",")) {
      newParams["expense_ids"] = newValue.expense_ids;
      editValueCount++;
    }

    if (newValue.device_type == "手机") {
      let device_type_detail = value.device_type_desc1;
      if (device_type_detail != initValue.device_type_detail) {
        newParams["device_type_detail"] = device_type_detail;
        editValueCount++;
      }

    } else {
      let device_type_detail = value.device_type_desc2;
      if (device_type_detail != initValue.device_type_detail) {
        newParams["device_type_detail"] = device_type_detail;
        editValueCount++;
      }
    }

    if (newValue.region != initValue.region) {
      newParams["region"] = this.serverSavedRegion(newValue.region);
      editValueCount++;
    }
    var isValueChanged = false;
    if (editValueCount > 0) {
      isValueChanged = true;
    }
   
    if(newValue.state == ProjectOperationFlowUtils.COLLECT_STATE.READY ){
        if(createType == CONSTANTS.CREATE_PROJECT_TYPE.READY2FORMAL){
            newParams["operation"] = newValue.state+1;//预立项转正operation +1
        } 
    }
    return {
      isValueChanged: isValueChanged,
      data: newParams
    };
  },

  createAndUpdateProject(operationType, params, initParams,createType) {
    var that = this;
    return new Promise((resolve, reject) => {

      if (operationType == CONSTANTS.PROJECT_OPERATION.CREATE) {
        //创建项目
        let newParams = that.createPreProcessProjectInfo(params,createType).data;
        ProjectAPIS.postJobs(newParams)
          .then(result => {
            resolve(result);
          })
          .catch(error => {
            reject(error);
          });
      } else if (operationType == CONSTANTS.PROJECT_OPERATION.EDIT) {
        let editResult = that.editPreProcessProjectInfo(params, initParams,createType);
        if (editResult.isValueChanged) {
          ProjectAPIS.putJobs(params.form.id, editResult.data)
            .then(result => {
              resolve(result);
            })
            .catch(error => {
              reject(error);
            });
        } else {
          resolve({
            data: {
              id: params.form.id
            }
          });
        }
      }
    });
  },

  getResearchDirections() {
    return new Promise((resolve, reject) => {
      ProjectAPIS.getResearchDirections({page:-1})
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getResearchDirectionCollectionElements(researchDirectionId) {
    return new Promise((resolve, reject) => {
      ProjectAPIS.getResearchDirectionCollectionElements(researchDirectionId,{page:-1})
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getCollectionElementItems(elementId) {
    return new Promise((resolve, reject) => {
      ProjectAPIS.getCollectionElementItems(elementId,{page:-1})
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getCollectionTargets() {
    return new Promise((resolve, reject) => {
      ProjectAPIS.getCollectionTargets({page:-1})
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getCollectionTargetItems(targetId) {
    // return new Promise((resolve, reject) => {
    //   ProjectAPIS.getCollectionTargetItems(targetId,{page:-1})
    //     .then(result => {
    //       resolve(result);
    //     })
    //     .catch(error => {
    //       reject(error);
    //     });
    // });
    return  ProjectAPIS.getCollectionTargetItems(targetId,{page:-1});
  },

  getCollectionExpenseDepartments() {
    return new Promise((resolve, reject) => {
      ProjectAPIS.getCollectionExpenseDepartments({page:-1})
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  
  getSceneElements(){
    return new Promise((resolve, reject) => {
        ProjectAPIS.getSceneElements({page:-1})
          .then(result => {
            resolve(result);
          })
          .catch(error => {
            reject(error);
          });
      });
  },

  getMoreData(projectId) {
    return new Promise((resolve, reject) => {
      ProjectAPIS.getHubble(projectId)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

export default ProjectServices



// WEBPACK FOOTER //
// ./src/js/modules/project/services/project-services.js